import { inject, Pipe, PipeTransform } from '@angular/core';
import { unwrapI18n } from '../functions/unwrap-i18n.function';

/** Unwraps an i18n mapped value using {@link TranslateService} configuration. */
@Pipe({ name: 'i18n', standalone: true })
export class UnwrapI18nPipe implements PipeTransform {
  transform = inject(unwrapI18n);
}
